import * as React from 'react';
import { useSelector } from 'react-redux';

import { AnswerTextContainer } from './AnswerTextContainer';
import { UserStatusContainer } from './UserStatusContainer';
import { NewAnswer } from '../../components/NewAnswer';
import { getIsAgent } from '../../selectors/user';
import { getIsReviewTab } from '../../selectors/tabs';
import { AnonymousContainer } from './AnonymousContainer';
import { NameContainer } from './NameContainer';

export const NewAnswerContainer = (): React.JSX.Element => {
  const isAgent = useSelector(getIsAgent);
  const isReview = useSelector(getIsReviewTab);

  const showUserStatus = !isAgent && isReview;

  return (
    <NewAnswer
      userInfo={
        isAgent ? null : (
          <>
            <NameContainer />
            {showUserStatus && <UserStatusContainer />}
          </>
        )
      }
      answer={<AnswerTextContainer />}
      anonymous={isAgent ? null : <AnonymousContainer />}
    />
  );
};
